module.exports = __webpack_public_path__ + "cidade-a-p--301fba60.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/cidade-a-p.png
// module id = 234
// module chunks = 0